'use strict';

/**
 * @name MapOptions
 * @type {Object}
 * @property {string}       type
 * @property {String}       gmap_selector      マップ要素のセレクタ
 * @property {Object}       gmap_options_default GoogleMapに渡すオプション（デフォルト）
 * @property {Object}       gmap_options       GoogleMapに渡すオプション
 * @property {String}       container_selector     マップを囲う要素のセレクタ
 * @property {String[]}     outer_frame_selectors  マップサイズ調整用、マップ外の要素のセレクタ
 */

/**
 * GoogleMapで表示する
 * 
 * @name GoogleMap
 * @extends {Map}
 */
export default class GoogleMap{
  /**
   * @param {EventEmitter} mapEvents
   * @param {PopupFactory} popupFactory
   * @param {PlaceType} placeType
   * @param {MapOptions} options
   */
  constructor(mapEvents, popupFactory, placeType, options) {
    this.mapEvents = mapEvents;
    this.popupFactory = popupFactory;
    this.placeType = placeType;
    this.options = options;
    this.gevent = google.maps.event;
    this.gmarkers = {};
    this.interval = 0;
    this.stepCount = 0;
    this.timerID = [];
    this.displayingPlaces = null;
    this.forceMarkerOpen = false;
    this.markerMargin = {
      set: this.options.setMarkerMargin,
      weight: this.options.marginWeight,
      map: {},
      index: {}
    };
  }
  /**
   * マップを作成
   * 
   * @access private
   * @returns {google.maps.Map}
   */
  createMap() {
    var map_canvas = $(this.options.gmap_selector);
    var opt = $.extend(this.options.gmap_options_default, this.options.gmap_options);
    return new google.maps.Map(map_canvas[0], opt);
  }
  /**
   * 初期化
   * 
   * @access public
   */
  reset() {

    // TODO
    this.ginfo_window = new google.maps.InfoWindow({
      maxWidth: 300
    });

    // FIXME: API sampleでは scroll:auto になっているが、何故かつかないので無理矢理変更
    // scrollしないと高さの低いブラウザで閲覧した時に、ポップアップの吹き出し表示が崩れる
    this.gevent.addListener(this.ginfo_window, 'domready', function() {
      $(this.content).parent().css({
        'overflow-y': 'auto',
        'min-height': '70px'
      });
      
    });

  }
  /**
   * ih.start()で呼ばれる
   * 
   * @access public
   */
  start() {
    this.gmap = this.createMap();
    this.registerChangeZoomEvent();
  }
  setStyledMap() {
  
    let style = {
      styles: [
        {
          "elementType": "labels.text",
          "stylers": [
            {"visibility": "off"}
          ]
        }
      ]
    };
  
    this.gmap.setOptions(style);
    
    // 以下はコントロールで切り替えるための方法？
    // // Create an array of styles.
    // let styles = [
    //   {
    //     "elementType": "labels.text",
    //     "stylers": [
    //       { "visibility": "off" }
    //     ]
    //   },
    //   // {
    //   //   "elementType": "labels.icon",
    //   //   "stylers": [
    //   //     { "visibility": "off" }
    //   //   ]
    //   // }
    // ];
    //
    // let styledMap = new google.maps.StyledMapType(styles,
    //   {name: "Styled Map"});
    //
    // this.gmap.mapTypes.set('map_style', styledMap);
    // this.gmap.setMapTypeId('map_style');
    
  }

  /**
   * マップ中心位置、基準位置を変更する
   * 
   * @access public
   * @param {google.maps.LatLng} latlng
   */
  setCenterAndCurrentLocation(latlng) {
    // fit_boundsを使う場合、中心位置に移動は意味をなさない
    this.gmap.setCenter(latlng);
    this.updateCurrentLocation(latlng);
  }
  /**
   * 検索の基準位置を変更する
   *
   * @access public
   * @param {google.maps.LatLng} latlng
   * @returns {google.maps.LatLng}
   */
  updateCurrentLocation(latlng) {
    if (!latlng) {
      var c = this.gmap.getCenter();
      latlng = this.createLatLng(c.lat(), c.lng());
    }
    this.displayBaseMarker(latlng);

    this.current_search_location = latlng;
    return this.current_search_location;
  }
  /**
   * 検索時の基準位置を取得する
   *
   * @access public
   * @returns {google.maps.LatLng}
   */
  getCurrentSearchLocation(){
    return this.current_search_location;
  }
  /**
   * 検索範囲を指定した場合に用いる、円を表示
   *
   * @access public
   * @param r
   */
  displayCircle(r) {
    /**
     * マップの中心に赤い円を表示する
     */
    if (radius == "all") {
      return 0;
    }
    
    var cc = this.center_circle;
    var latlng = this.getCurrentSearchLocation();
    var radius = parseFloat(r) * 1000;

    if (cc != "") {
      if (this.center_circle) {
        this.center_circle.setMap(null);
      }
      this.center_circle = "";
    }

    this.center_circle = new google.maps.Circle({
      center: latlng, // 中心点(google.maps.LatLng)
      fillColor: '#ff0000', // 塗りつぶし色
      fillOpacity: 0.03, // 塗りつぶし透過度（0: 透明 ⇔ 1:不透明）
      map: this.gmap, // 表示させる地図（google.maps.Map）
      radius: radius, // 半径（ｍ）
      strokeColor: '#ff0000', // 外周色 
      strokeOpacity: 1, // 外周透過度（0: 透明 ⇔ 1:不透明）
      strokeWeight: 1         // 外周太さ（ピクセル）
    });
  }
  /**
   * マーカーを全消去
   *
   * @access public
   */
  clearMarkersAll() {
    /**
     * 表示されているすべてのマーカーを非表示
     */
    this.ginfo_window.close();

    // gmarkersは連想配列
    if (this.gmarkers.places){
      $.each(this.gmarkers.places, function(k) {
        this.setMap(null);
      });
    }

    this.gmarkers.places = {};
  }
  clearStaticMarkersAll() {
    
    if (this.gmarkers.static){
      $.each(this.gmarkers.static, function(k) {
        this.setMap(null);
      });
    }
    
    this.gmarkers.static = {};
  }
  markerMarginValue(index){
    
    let list = [
      [0, 0], [0, 1], [-1, 0], [0, -1], [1, 0], [1, 1], [-1, -1], [1, -1], [-1, 1]
      // [0, 0], [1, 0], [1, -1], [0, 1], [-1, 1], [-1, 0], [-1, -1], [0, -1], [1, -1]
    ];
    
    if (index >= list.length) {
      index = index % list.length;
    }
    
    return list[index];
  
  }
  /**
   * google.maps.Markerを生成し、地図上に配置する。
   * オーバーライド許可するが、markerを内部管理する必要があるのでcreateMarker以外からは呼ばないように
   *
   * @access private
   * @param {type} jm
   * @returns {google.maps.Marker}
   */
  _createMarkerObject(jm){
    // マーカーマージン
    let latlng;
    if (this.markerMargin.set) {
      latlng = this.createMarginedLatLng(jm.lat, jm.lng);
    } else {
      latlng = this.createLatLng(jm.lat, jm.lng);
    }
    
    // デフォルトアイコン（施設IDによる自動割り当て）
    let markerIcon = {
      url: this.placeType.getMarkerIcon(jm.type),
      labelOrigin: new google.maps.Point(10, 35)
    };
    // デフォルトラベル
    let markerLabel = {
      color: "#493E26",
      fontSize: "14px",
      fontWeight: '400',
      fontFamily: 'ヒラギノ丸ゴ Pro W4,ヒラギノ丸ゴ Pro,Hiragino Maru Gothic Pro,ヒラギノ角ゴ Pro W3,' +
        'Hiragino Kaku Gothic Pro,HG丸ｺﾞｼｯｸM-PRO,HGMaruGothicMPRO',
      text: jm.name
    };
  
    // 施設オブジェクトがアイコン非表示設定の場合はラベルのみ表示する
    if ('showIcon' in jm && !jm.showIcon) {
      markerIcon = 'img/nothing.png';
      markerLabel.color = 'black';
      markerLabel.fontWeight = '600';
    }
    // アイコン表示設定が無い、またはアイコンが表示設定の場合、
    else if (!('showIcon' in jm) || jm.showIcon) {
      // 施設オブジェクトごとにアイコン画像の指定がある場合、その画像をマーカに用いる
      if ('icon_pin' in jm) {
        markerIcon = {
          url: jm.icon_pin,
          labelOrigin: new google.maps.Point(10, 40)
        };
      }
    }
  
    // 2行目用ラベル
    if ('newline' in jm && jm.newline) {
      markerIcon = {
        url: 'img/nothing.png',
        labelOrigin: new google.maps.Point(0, 20)
      };
    }
    
    const marker = new google.maps.Marker({
      map: this.gmap,
      position: latlng,
      zIndex: 1000,
//    optimized: false,
      icon: markerIcon,
      name: jm.name
    });
  
    if (this.options.useDefaultMarkerLabel || ('static' in jm && jm.static) ) {
      marker.setLabel(markerLabel);
    }
    
    return marker;
  }
  
  /**
   *
   * @param {google.maps.Marker} marker
   * @param {Object} labelStyle
   */
  setMarkerLabel (marker, labelStyle = null) {
    if (labelStyle) {
      if (labelStyle.text === '') {
        marker.setLabel(null);
      } else {
        marker.setLabel(labelStyle);
      }
    }
  }
  
  /**
   * 同じ緯度・経度の場合にマージンを付与した緯度・経度を作成する
   * @param lat
   * @param lng
   * @returns {google.maps.LatLng}
   */
  createMarginedLatLng(lat, lng) {
    if (!this.markerMargin.map[ lat + ':' + lng ]){
      this.markerMargin.map[ lat + ':' + lng ] = [
        [0, 0], [0, 1], [0, -1], [0, 2], [0, -2], [0, 3], [0, -3], [0, 4], [0, -4],
        [-1, 0], [-1, 1], [-1, -1], [-1, 2], [-1, -2], [-1, 3], [-1, -3], [-1, 4], [-1, -4]
      ];
      this.markerMargin.index[ lat + ':' + lng ] = 0;
    }
  
    let index = this.markerMargin.index[ lat + ':' + lng ];
    let len = this.markerMargin.map[ lat + ':' + lng ].length;
    let half = len / 2;
    
    if (index >= len) {
      this.markerMargin.index[ lat + ':' + lng ] = index = index % len;
      for (let i = 0; i < len; i++) {
        if (i >= half) {
          this.markerMargin.map[ lat + ':' + lng ][i][0]--;
        } else {
          this.markerMargin.map[ lat + ':' + lng ][i][0]++;
        }
      }
    }
  
    let dx = this.markerMargin.map[ lat + ':' + lng ][index][0];
    let dy = this.markerMargin.map[ lat + ':' + lng ][index][1];
    let x = this.markerMargin.weight * dx;
    let y = this.markerMargin.weight * dy;
    
    this.markerMargin.index[ lat + ':' + lng ]++;
  
    return this.createLatLng(lat + x, lng + y);
  }
  
  /**
   * 現在表示中のマーカーを取得
   *
   * @access public
   * @returns {Array.<google.maps.Marker>}
   */
  getDisplayMarkers(){
    return this.gmarkers['places'];
  }
  /**
   * 施設マーカーを取得
   *
   * @access public
   * @param id
   * @returns {google.maps.Marker}
   */
  getPlaceMarker(id){
    if (!this.gmarkers['places']) {
      this.gmarkers['places'] = {};
    }
    return this.gmarkers['places'][id];
  }
  getStaticMarkers(){
    return this.gmarkers['static'];
  }
  /**
   * 表示予定の施設オブジェクトを取得
   *
   * @returns {Array|*|null}
   */
  getDisplayingPlaces(){
    return this.displayingPlaces;
  }
  getTimerID(){
    return this.timerID;
  }
  /**
   * 施設オブジェクトから、地図上にマーカーをプロットする
   *
   * @access protected
   * @param {Place} jm
   * @returns {google.maps.Marker}
   */
  createMarker(jm) {
    if (!jm) return;

    if (!this.gmarkers['places']) {
      this.gmarkers['places'] = {};
    }
    if (!this.gmarkers['static']) {
      this.gmarkers['static'] = {};
    }

    if (this.gmarkers['places'][jm.id]){
      // すでに生成されているので作る必要なし
      return this.gmarkers['places'][jm.id];
    }
    /*
     * マーカー生成
     */
    var marker = this._createMarkerObject(jm);
  
    // 常設マーカを保存する
    // 検索と連動した表示・非表示の対象にならない
    if ('static' in jm && jm.static) {
      this.gmarkers['static'][jm.id] = marker;
    }
  
    // 常設マーカ以外のマーカを保存する
    // 検索と連動した表示・非表示の対象になる
    if (!('static' in jm)) {
      this.gmarkers['places'][jm.id] = marker;
    }
    
    return marker;
  }
  /**
   * マーカーのポップアップを生成し、イベントリスナーに登録する
   *
   * @access protected
   * @param {Place} place
   * @param {google.maps.Marker} marker
   * @return {DOMElement}
   */
  createMarkerPopup(place, marker){
    // ポップアップのDOM/HTML
    var popup = this.popupFactory.build(place);
    
    if (!popup) {
      return;
    }
    /**
     * マーカーにイベントリスナー登録
     */
    this.gevent.addListener(marker, 'click', () => {
      // コア側にイベントを渡す（その後、ポップアップを開くかどうかはコアに任せる）
      this.mapEvents.emit('ihClickMarker', place, marker, popup);
    });
    
    return popup;
  }
  /**
   * マーカーポップアップを開く
   * 
   * @access public
   * @param marker
   * @param popup
   */
  toggleMarkerPopup(marker, popup){
    var that = this;
    // toggleする
    if (!this.forceMarkerOpen && that.isOpenMarkerPopup(popup)){
      that.closeMarkerPopup();
    }else{
      that.setMarkerPopup(marker, popup);
      this.forceMarkerOpen = false;
    }
  }

  /**
   * 指定のマーカーポップアップが開いているか？
   * 
   * @param popup
   * @returns {boolean}
   */
  isOpenMarkerPopup(popup){
    const currentPlaceId = $('.info-window').data('place-id');
    const newPlaceId = $(popup).data('place-id');
    return currentPlaceId === newPlaceId;
  }
  /**
   * マーカーポップアップを閉じる
   * 
   */
  closeMarkerPopup(){
    var f = this.ginfo_window;
    f.close();
    f.setContent(""); // closeしても要素は残る
  }
  /**
   * 
   * @param popup
   */
  setMarkerPopup(marker, popup){
    var f = this.ginfo_window;
    f.setContent(popup);
    var panorama = this.gmap.getStreetView();
    if (panorama.getVisible()){
      f.open(panorama, marker);
    }else{
      f.open(this.gmap, marker);
    }
  }
  /**
   * マーカーを地図上にプロットする
   *
   * @access public
   * @param {Request} request
   * @param {Array} places
   */
  displayMarkers(request, places) {
    
    // マーカの描画時間の間隔
    let interval = this.interval;
    
    // [試作] 再生モード
    let stepCount = this.stepCount;
    let len = 0;
    if (stepCount !== 0) {
      len = stepCount;
    } else {
      len = places.length;
    }
    
    // 表示予定の施設オブジェクトを取得する
    this.displayingPlaces = places;
  
    for (let i = 0; i < len; i++) {
      
      let place = places[i];
      
      if (!place) continue;
  
      this.timerID[i] = setTimeout(() => {
        
        // マーカーを生成して表示
        let marker = this.createMarker(place);
        
        // ポップアップを生成してリスナーに登録
        let popup = this.createMarkerPopup(place, marker);
  
        // マーカが1つ表示されるごとに発生するイベント
        $(this).trigger('ihDisplayedOneMarker', [places, place, marker, popup]);
  
        // 全マーカ表示後に発生するイベント
        if (i === places.length - 1 ) {
  
          $(this).trigger('ihDisplayedAllMarkers', [places, marker, popup]);
  
        }
        
      }, i * interval);
      
    }

  }

  /**
   * 基準位置マーカーを表示
   * 
   * @param {google.maps.LatLng} latlng
   */
  displayBaseMarker(latlng) {
    if (this.options.showBaseMarker) {
      var that = this;
  
      // すでに配置済みのBaseMarkerを除去
      if (this.gmarkers['center']) {
        this.gmarkers['center'].setMap(null);
      }
      this.gmarkers['center'] = null;
  
      // マーカーを真ん中に表示
      var marker = new google.maps.Marker({
        map: this.gmap,
        position: latlng,
        draggable: true, // draggableの場合zIndexにかかわらず最前面になる？？
        zIndex: 100
//      animation: google.maps.Animation.DROP
      });
      this.gmarkers['center'] = marker;
  
      // ドラッグ
      this.gevent.addListener(marker, 'dragstart', function() {
        marker.setAnimation(google.maps.Animation.BOUNCE);
      });
      this.gevent.addListener(marker, 'drag', function() {
        marker.setAnimation(google.maps.Animation.BOUNCE);
      });
      this.gevent.addListener(marker, 'dragend', function() {
        marker.setAnimation(null);
        that.updateCurrentLocation(marker.position);
        $(that).trigger('ihUpdateCenterMarker');
      });
    }
  }
  /**
   * 
   * @param lat
   * @param lng
   * @returns {google.maps.LatLng}
   */
  createLatLng(lat, lng) {
    return new google.maps.LatLng(lat, lng);
  }

  /**
   * 中心位置オブジェクトを取得
   *
   * @access public
   * @returns {google.maps.LatLng}
   */
  getCenter() {
    return this.gmap.getCenter();
  }
  /**
   *
   * @access public
   * @params {google.maps.LatLng} latlng
   */
  setCenter(latlng) {
    this.gmap.setCenter(latlng);
  }
  /**
   * 指定された座標に地図を移動させる
   *
   * @access public
   * @param {number} lat
   * @param {number} lng
   * @param {boolean?} circle
   * @return {boolean} 戻り値
   */
  moveMap(lat, lng, circle) {
    var latlng = this.createLatLng(lat, lng);
    this.gmap.setCenter(latlng);
    this.displayBaseMarker(latlng);
    if (circle){
      this.displayCircle(this.getRadius());
    }
  }
  /**
   * 指定施設に移動して、マーカークリック動作を起動
   * 
   * @access public
   * @param place
   */
  moveAndFocus(place){
    if (place.lat && place.lng){
      this.map.moveMap(place.lat, place.lng, false);
    }
    this.map.focusMarker(place.id);
  }
  /**
   * マーカーがクリックされた際の処理
   * 
   * @access public
   */
  // focusMarker(markerNum) {
  //   if (markerNum && markerNum != "none") {
  //     this.gevent.trigger(this.gmarkers.places[markerNum], 'click');
  //   }
  // }
  focusMarker(place) {
    let markerNum = place.id;
    if (markerNum && markerNum !== "none") {
      this.gevent.trigger(this.gmarkers.places[markerNum], 'click');
    }
  }
  /**
   * 仕方なく外からgooglemapを操作したい時
   * 
   * @access public
   * @returns {google.maps.Map}
   */
  getMap() {
    return this.gmap;
  }
  /**
   * 指定の施設が全て表示されるようにズームと位置調整する
   * 
   * @param {Array} places
   */
  fitBounds(places, onFitBounds = true) {
    
    if(!onFitBounds){
      return;
    }
    
    var bounds = new google.maps.LatLngBounds();
    if (places.length > 0){
      _.each(places, (place) => {
        if (place.lat && place.lng){
          bounds.extend(this.createLatLng(place.lat, place.lng));
        }
      });
      bounds.extend(this.getCurrentSearchLocation());
      // 基準位置１つだけになると最も大きく拡大されてしまうので初期位置も追加
      // => しかしおすすめコースの場合に思ったように拡大されないので無効化
      // bounds.extend(that.getInitLocation());
      this.gmap.fitBounds(bounds);
    }
  }
  
  // ビューポートの端の座標を取得する
  // (順に東西南北端セット、北端、南端、東端、西端)
  getBounds(){
    return this.gmap.getBounds();
  }
  getNorthEnd(){
    return this.getBounds().getNorthEast().lat();
  }
  getSouthEnd(){
    return this.getBounds().getSouthWest().lat();
  }
  getEastEnd(){
    return this.getBounds().getNorthEast().lng();
  }
  getWestEnd(){
    return this.getBounds().getSouthWest().lng();
  }
  
  /**
   * マップの中心に十字を表示する
   *
   * @uses gmap, gmap_selector, cmh_id, cmv_id
   * @returns {undefined}
   */
  displayCenterCross(){
    
    if (this.options.center_cross.using_overlay) {
      
      // 中心にカーソル
      // var crosshairShape = {coords:[0,0,0,0],type:'rect'};
      
      let marker = new google.maps.Marker({
        map: this.gmap,
        zIndex: 10,
        icon: {
          url: 'img/center_cross.png',
          anchor: new google.maps.Point(12, 12) // 画像変更した場合 anchorPoint も調整する必要あり
        }
        //	shape: crosshairShape
      });
      
      marker.bindTo('position', this.gmap, 'center');
      
    } else {
      
      let that = this;
      let center_marker_timer = setInterval(() => {
        if (that.gmap.getDiv().firstChild) {
          if (that.gmap.getDiv().firstChild.hasChildNodes()) {
            that.drawCenterCross();
            clearInterval(center_marker_timer);
          }
        }
      }, 25);
      
      $(window).bind("resize", (event) => {
        that.drawCenterCross();
      });
      
    }
  }
  /**
   * マップの中心に十字を描画する
   *
   * @uses gmap, gmap_selector
   * @returns {undefined}
   */
  // Todo: 描画できない
  drawCenterCross() {
    
    /*
     canvas の width, height を % 指定にしている際は % 単位の値が入るので注意が必要
     browser依存するが % でも getComputedStyle() で計算後の値がとれる
     http://d.hatena.ne.jp/amachang/20070611/1181554170
     jquery, zepto の width(), height() により解決
     2011/10/12 - 現在は中心になっていない（上部のナビゲーション分のずれがある）
     */
    
    let cmh, cmv, mapWidth, mapHeight, x, y;
    let elem = $('#centerMarkHorizontal')[0];
    
    if (!elem) {
      
      // cmh = this.d.createElement("div");
      cmh = document.createElement("div");
      cmh.id = 'centerMarkHorizontal';
      
      // cmv = this.d.createElement("div");
      cmv = document.createElement("div");
      cmv.id = 'centerMarkVertical';
      
    } else {
      cmh = elem;
      cmv = elem;
    }
    
    let map_canvas = $(this.options.gmap_selector);
    
    mapWidth = parseInt(map_canvas.width());
    mapHeight = parseInt(map_canvas.height());
    
    x = (mapWidth - 24) / 2;  // センターマークの中心位置（X座標）
    y = (mapHeight - 24) / 2; // センターマークの中心位置（Y座標）
    
    // centerMarkerHorizontal
    cmh.style.left = x + "px";
    cmh.style.top = ((mapHeight - 4) / 2) + "px";
    
    // centerMarkerVertical
    cmv.style.left = ((mapWidth - 4) / 2) + "px";
    cmv.style.top = y + "px";
    
    // append
    //        this.gmap.getDiv().firstChild.appendChild(cmh);
    //        this.gmap.getDiv().firstChild.appendChild(cmv);
    // ? twitter bootstrap2 に変更後、preppendしなければ表示されなくなった
    
    this.gmap.getDiv().insertBefore(cmh, this.gmap.getDiv().firstChild);
    this.gmap.getDiv().insertBefore(cmv, this.gmap.getDiv().firstChild);
  }
  
  /**
   * 静的画像レイヤーを作成する
   *
   * @param {String} url
   * @param {Object} bounds {north(maxLat = maxY), south(minLat = minY), east(maxLon = maxX), west(minLon = minX)}
   * @param {Number} opacity
   * @returns {google.maps.GroundOverlay}
   */
  createStaticImageLayer (url, bounds, opacity = 1) {
    return new google.maps.GroundOverlay( url, bounds, {opacity: opacity});
  }
  
  addLayer (layer) {
    layer.setMap(this.gmap);
  }
  
  removeLayer (layer) {
    layer.setMap(null);
  }
  
  registerChangeZoomEvent() {
    google.maps.event.addListener(this.gmap, 'zoom_changed', () => {
      this.mapEvents.emit('ihChangeZoom', this.getZoom());
    });
  }
  
  getZoom () {
    return this.gmap.getZoom();
  }
  setZoom (zoom) {
    this.gmap.setZoom(zoom);
  }
  
  setMaxZoom (maxZoom) {
    this.gmap.setOptions({maxZoom: maxZoom})
  }
}




// WEBPACK FOOTER //
// ./map/js/ih/map/GoogleMap.js